import * as Sentry from '@sentry/react';
import { clearStorageComponent } from './session';
import { LOGIN } from '@/router/routes';

// Module-level flag prevents multiple concurrent 401 responses from
// triggering multiple redirects (race condition when several requests fail at once).
let isLoggingOut = false;

/**
 * Call from axios response interceptors when a 401 is received.
 * Clears the session, resets Sentry user context, and redirects to login.
 * Safe to call multiple times — only the first call acts.
 * Skips redirect if already on the login page (avoids redirect loops on auth endpoints).
 */
export function handleUnauthorized(): void {
  // Already in progress — ignore subsequent 401s from concurrent requests
  if (isLoggingOut) return;

  // Already on the login page — don't redirect (avoids loop on login/signup 401s)
  if (window.location.pathname === LOGIN) return;

  isLoggingOut = true;
  clearStorageComponent();
  Sentry.setUser(null);
  window.location.replace(LOGIN);
}
